import { render, staticRenderFns } from "./TeachingUserCourseHourModal.vue?vue&type=template&id=54a9136e"
import script from "./TeachingUserCourseHourModal.vue?vue&type=script&lang=js"
export * from "./TeachingUserCourseHourModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports